import React from 'react';
import { CtaBlock } from '../CtaBlock';
import { AUTHOR_IMAGE } from '../../data/content';
export function AboutSection() {
  return <section className="bg-navy-50 py-14 sm:py-20" aria-labelledby="about-title" data-id="element-64" data-mp="chhwxa45miq9">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-65" data-mp="hf00sm3be7re">
        <div className="mx-auto max-w-3xl text-center" data-id="element-66" data-mp="lhehazjigvfi">
          <span className="inline-block rounded-full bg-navy-800 px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-white sm:text-xs" data-id="element-67" data-mp="lizbgo1wyccu">
            About Dr. Karito
          </span>
          <h2 id="about-title" className="mt-4 text-2xl font-black leading-tight tracking-tight text-navy-900 sm:text-3xl md:text-4xl" data-id="element-68" data-mp="ve9e9e04ynro">
            A message from Dr. Karito
          </h2>
        </div>

        <div className="mt-9 grid items-start gap-7 md:grid-cols-[minmax(0,300px)_minmax(0,1fr)] md:gap-10" data-id="element-69" data-mp="1978uji7qsm0a">
          <figure className="mx-auto w-full max-w-[280px] md:mx-0 md:max-w-none" data-id="element-70" data-mp="1e625b2vn9ywr">
            <img src={AUTHOR_IMAGE} alt="Dr. Karito, physician and creator of the Clinical Decision System for Diabetes" className="w-full rounded-3xl border-4 border-white object-cover shadow-[0_14px_36px_rgba(6,18,37,0.18)]" loading="lazy" data-id="element-71" data-mp="1dmfedi6yum4u" />
            <figcaption className="mt-3 text-center text-[12.5px] font-bold uppercase tracking-wide text-navy-700 md:text-left" data-id="element-72" data-mp="zmw8kw1mnmvp">
              Dr. Karito — Creator of the Clinical Decision System
            </figcaption>
          </figure>

          <div className="space-y-4 text-pretty text-[14.5px] leading-relaxed text-navy-700 sm:text-base" data-id="element-73" data-mp="1scmlj1riwiq8">
            <p data-id="element-74" data-mp="1nj0m4badebcd">
              When I first started caring for patients with diabetes, I realized that the real
              challenge wasn’t simply knowing the guidelines.
            </p>
            <p className="font-bold text-navy-900" data-id="element-75" data-mp="2g1nzf4j4km2w">
              The real challenge was making the next decision when the patient was sitting right in
              front of me.
            </p>
            <ul className="space-y-1 font-semibold text-navy-800" data-id="element-76" data-mp="9dx40elg50e7">
              <li data-id="element-77" data-mp="ddz4wljcxpsf">• With limited time.</li>
              <li data-id="element-78" data-mp="ddpgh2dynqou">• With multiple comorbidities.</li>
              <li data-id="element-79" data-mp="3vsgfa2f4jzgg">• With competing clinical priorities.</li>
              <li data-id="element-80" data-mp="3vryfwwx6154b">• And with the responsibility of deciding what to evaluate next.</li>
            </ul>
            <p data-id="element-81" data-mp="4jswnu89qqcl">That’s why I created the Clinical Decision System for Diabetes.</p>
            <p data-id="element-82" data-mp="3lshamgltst8v">
              Not to replace clinical judgment — but to provide a structure that can help you
              organize your thinking, move through complex situations more efficiently, and bring
              current evidence into your daily workflow.
            </p>
            <p data-id="element-83" data-mp="3htgs6z79fsme">
              I created the kind of resource I wish I had when I was facing those decisions more
              frequently for the first time.
            </p>
            <blockquote className="rounded-2xl border-l-4 border-clinic-500 bg-white p-4 text-[15px] font-bold text-navy-900 sm:text-base" data-id="element-84" data-mp="1g1ly1xh1s6rx">
              My hope is that this system gives you a clearer path forward whenever you’re asking
              yourself: “What’s the next step?”
            </blockquote>
            <p className="font-black text-navy-900" data-id="element-85" data-mp="1yxkp0ncm9dhy">— Dr. Karito</p>
          </div>
        </div>

        <CtaBlock kicker="Bring a clearer structure into your consultation." label="👉 I want to start today" data-id="element-86" data-mp="1u6cfzsf77u5b" />
      </div>
    </section>;
}